import { Checkbox, Table } from 'antd';
import styled from 'styled-components';

export const Container = styled('div')`
  padding: 0;
  padding-top: 1rem;
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  height: 100%;
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  margin-left: auto;
`;

export const A4Container = styled.div`
  * {
    font-family: 'Times New Roman', Times, serif !important;
  }
  padding: 0 10mm;
  width: 210mm;
  page-break-inside: auto;

  overflow: auto;
  background: white;
  box-shadow: 0 0 5mm rgba(0, 0, 0, 0.3);

  position: relative;
  height: 100%;

  .page-break {
    page-break-before: always;
  }
`;
export const StyledStatisticTable = styled(Table)`
  tr.standard-row {
    td {
      font-weight: 900;
    }
  }

  * {
    border-color: #333 !important;
    background: transparent;
  }

  table {
    border-collapse: collapse !important;
  }

  .ant-table-container {
    border-radius: 0 !important;
    border-left: none !important;

    td,
    th {
      border-left: 0.5px solid #333 !important;
      border-right: 0.25px solid #333 !important;
    }

    tbody {
      border-right: none !important;
      border-left: none !important;

      tr {
        border-right: none !important;
        border-left: none !important;
      }
    }

    > * {
      border-radius: 0 !important;
    }

    .ant-table-cell {
      padding: 6px !important;
      color: #333;
      background: transparent;
    }
  }

  thead > tr > th.ant-table-cell {
    font-weight: 900;
    font-size: 16px;
    text-align: center;
  }

  tbody > tr > td {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.1;
  }

  tr {
    page-break-inside: avoid;
  }

  // .table {
  //   padding-top: 10px;
  //   page-break-before: auto;
  //   -webkit-page-break-before: auto;
  //   -moz-page-break-before: auto;

  //   page-break-inside: avoid;
  //   -webkit-page-break-inside: avoid;
  //   -moz-page-break-inside: avoid;
  // }

  // table tr {
  //   page-break-before: auto;
  //   page-break-inside: avoid;
  // }
`;

export const HiddenContainer = styled('div')`
  position: absolute;
  top: -9999px;
  left: -9999px;
  opacity: 0;
`;

export const HeaderContainer = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  gap: 10px;
`;

export const HeaderColumn = styled(HeaderContainer)`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    position: relative;

    word-break: break-word;
    text-align: center;
  }

  p.border-bottom::after {
    content: '';
    display: block;
    width: 50%;
    border-bottom: 1.5px solid #333;
    position: absolute;
    left: 50%;

    transform: translateX(-50%);
    bottom: -8px;
  }

  .under-border {
    margin-top: 16px;
  }

  .sub-title {
    font-weight: 700;
    &.department-name {
      font-size: 18.6px;
      margin-top: 1rem;
      text-transform: uppercase;
    }
  }

  .italic {
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
  }
`;

export const TitleContainer = styled('div')`
  margin-top: 4rem;
  margin-bottom: 4rem;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;

  p {
    margin: 0;
    line-height: 1.2;
    font-weight: 700;
  }

  p.main-title {
    font-size: 18.6px;
  }
`;

export const FooterContainer = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  width: 100%;
  gap: 2rem;
  margin-top: 1.5rem;

  page-break-before: auto;
  -webkit-page-break-before: auto;
  -moz-page-break-before: auto;

  page-break-inside: avoid;
  -webkit-page-break-inside: avoid;
  -moz-page-break-inside: avoid;
`;

export const SignArea = styled('div')`
  display: flex;
  flex-flow: column nowrap;
  width: max-content;
  align-items: center;

  p {
    margin: 0;
    font-size: 18.6px;
    line-height: 1.5;
  }

  .italic {
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
  }

  .footer {
    margin-top: 9rem;
    margin-bottom: 1rem;
  }

  .user-title,
  .position {
    font-weight: 700;
    font-size: 18.6px;
  }

  page-break-before: auto;
  -webkit-page-break-before: auto;
  -moz-page-break-before: auto;

  page-break-inside: avoid;
  -webkit-page-break-inside: avoid;
  -moz-page-break-inside: avoid;
`;

export const TableTitle = styled('p')`
  margin-top: 2rem;
  font-size: 18.6px;
  font-weight: 700;
`;

export const LastPageSection = styled.div`
  page-break-before: always;
  -webkit-page-break-before: always;
  -moz-page-break-before: always;

  page-break-inside: avoid;
  -webkit-page-break-inside: avoid;
  -moz-page-break-inside: avoid;
  padding-top: 2mm;
`;

export const UserInfoContainer = styled('div')`
  margin-top: 1rem;
  margin-bottom: 3rem;

  display: flex;
  flex-flow: column nowrap;

  p {
    margin: 0;
    font-size: 18.6px;

    span:first-child {
      display: inline-block;
      font-weight: 600;
    }
    span:last-child {
      display: inline-block;
      margin-left: 10px;
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  .title-row {
    * {
      font-weight: bold !important;
    }
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 10px;
  padding: 4px 0 4px 8px;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const StyledCheckbox = styled(Checkbox)`
  span {
    font-size: 16px;
  }
  .ant-checkbox-wrapper {
    color: #333;
  }

  .ant-checkbox-inner {
    border-color: #333;
    width: 14px;
    height: 14px;
    &:after {
      border-color: #fff;
    }
  }

  .ant-checkbox-inner::after {
    top: 60%;
    left: 30%;
    width: 4px;
    height: 5px;
    border-width: 1px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #333;
    border-color: #333;
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff;
  }

  &:hover .ant-checkbox-inner {
    border-color: #333;
  }
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #333;
  }
`;
